import { useState, useEffect, useCallback } from 'react'
import { API, API_ROUTER } from '../../../api'

export const useUserData = () => {
  const [userData, setUserData] = useState(null)
  const [requestSuccess, setRequestSuccess] = useState(false)

  const getMyData = useCallback(() => {
    API.request({
      ...API_ROUTER.user.getMyData,
    })
      .then(res => {
        setUserData(res)
        setRequestSuccess(true)
      })
      .catch(err => console.log(err))
  }, [])

  useEffect(() => {
    getMyData()
  }, [getMyData])

  return {
    userData,
    requestSuccess,
    getMyData,
  }
}
